import { formatRelative, isSameDay, format, isToday, differenceInWeeks } from "date-fns";
import { Email } from "./emailTypes";
import { getIntl } from "../localization/intl";

export const relativeSentMailDate = (date: Date) => {
	return (
		formatRelative(new Date(date), new Date()).charAt(0).toUpperCase() +
		formatRelative(new Date(date), new Date()).slice(1)
	);
};

export const filterMailsBySameDay = (emails: Email[]) => {
	return emails.filter((mail) => isSameDay(new Date(mail.sentDate), new Date()));
};

export const filterMailsByNotSameDay = (emails: Email[]) => {
	return emails.filter((mail) => !isSameDay(new Date(mail.sentDate), new Date()));
};

export const formatSentMailDateBySameDay = (date: Date) => {
	return isSameDay(new Date(date), new Date())
		? getIntl().formatMessage({ id: "EMAIL.list.today.text" })
		: format(new Date(date), "dd MMM yyyy");
};

export const formatSentMail = (date: Date) => {
	if (isToday(new Date(date))) {
		return format(new Date(date), "HH:mm");
	} else if (differenceInWeeks(new Date(date), new Date()) < 1) {
		return format(new Date(date), "EEEE");
	} else return format(new Date(date), "DD/MM/Y");
};
